// extracted by mini-css-extract-plugin
export default {"video_player":"VideoComponent_video_player__Z4o1M"};